@for (x of [].constructor(numberOfCells); track x; let i = $index) {
  <div
    [attr.data-index]="i"
    class="volume-cell grey">
  </div>
}
